import { render } from "./AppCodeReader.vue?vue&type=template&id=35bf67d2&scoped=true"
import script from "./AppCodeReader.vue?vue&type=script&lang=js"
export * from "./AppCodeReader.vue?vue&type=script&lang=js"

import "./AppCodeReader.vue?vue&type=style&index=0&id=35bf67d2&scoped=true&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35bf67d2"]])

export default __exports__